// Library imports
import React, { useEffect, useRef, useState } from "react";

// User Component imports
import OpsDialog from "../common/OpsDialog";
import { VOICE_KIND_GEMINI } from "./appearanceDefs";

const DEFAULT_TEXT = "こんにちは、テスト音声です。";

const formatTime = (sec) => {
    const s = Math.max(0, Math.floor(sec || 0));
    return Math.floor(s / 60) + ":" + String(s % 60).padStart(2, "0");
};

/**
 * ボイスの試聴。フッターが無いため×を出し、閲覧のみなので背景クリックで閉じる
 */
const VoicePreviewModal = ({ voice, onClose, onSynthesize }) => {
    const [text, setText] = useState(DEFAULT_TEXT);
    const [style, setStyle] = useState(voice.style_prompt || "");
    const [audioUrl, setAudioUrl] = useState(null);
    const [isGenerating, setIsGenerating] = useState(false);
    const [playing, setPlaying] = useState(false);
    const [time, setTime] = useState({ current: 0, duration: 0 });
    const audioRef = useRef(null);
    const isGemini = voice.kind === VOICE_KIND_GEMINI;

    useEffect(() => () => audioRef.current && audioRef.current.pause(), []);

    const generate = async () => {
        if (!text.trim() || isGenerating) return;
        setIsGenerating(true);
        const audioData = await onSynthesize(voice.id, text.trim(), isGemini ? style : "");
        setIsGenerating(false);
        if (!audioData) return;
        setAudioUrl("data:audio/wav;base64," + audioData);
        requestAnimationFrame(() => audioRef.current && audioRef.current.play().catch(() => {}));
    };

    const togglePlay = () => {
        const audio = audioRef.current;
        if (!audio || !audioUrl) return;
        if (audio.paused) audio.play().catch(() => {});
        else audio.pause();
    };

    const ratio = time.duration ? time.current / time.duration : 0;

    return (
        <OpsDialog show={true} className="ops-scope" title="ボイスプレビュー" width={600}
            subtitle={`(ID:${voice.id}) ${voice.name}`}
            showClose={true} onClose={onClose} bodyClassName="ops-voice-preview-body">
            <div className="ops-form-field">
                <span className="ops-field-label">読み上げるテキスト</span>
                <textarea className="ops-textarea" rows={3} value={text} placeholder="読み上げるテキストを入力" onChange={(e) => setText(e.target.value)} />
            </div>
            {isGemini &&
                <div className="ops-form-field">
                    <span className="ops-field-label">スタイル指示（任意）</span>
                    <input className="ops-input" value={style} placeholder="例: 明るく元気に" onChange={(e) => setStyle(e.target.value)} />
                </div>
            }
            <div>
                <button type="button" className="ops-footer-btn is-primary ops-voice-generate" disabled={isGenerating || !text.trim()} onClick={generate}>
                    <i className="bi bi-play-fill" />{isGenerating ? "生成中…" : "生成して再生"}
                </button>
            </div>
            <div className={"ops-audio-bar" + (audioUrl ? " is-ready" : "")}>
                <button type="button" className="ops-audio-toggle" onClick={togglePlay} disabled={!audioUrl}>
                    <i className={"bi " + (playing ? "bi-pause-circle" : "bi-play-circle")} />
                </button>
                <div className="ops-audio-track"><div className="ops-audio-progress" style={{ width: (ratio * 100) + "%" }} /></div>
                <span className="ops-audio-time">{formatTime(time.current)}</span>
                {audioUrl &&
                    <audio ref={audioRef} src={audioUrl}
                        onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} onEnded={() => setPlaying(false)}
                        onTimeUpdate={(e) => setTime({ current: e.target.currentTime, duration: e.target.duration })}
                        onLoadedMetadata={(e) => setTime({ current: 0, duration: e.target.duration })} />
                }
            </div>
        </OpsDialog>
    );
};

export default VoicePreviewModal;
